import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { resetFrontsByType } from '../../store/actions/products';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';

const SelectionButtons = props => {
  const {
    title,
    params,
    unit,
    selectionGroupName,
    setValue,
    activeValue,
    setWardrobesConfigs,
    wardrobesConfigs,
    resetFrontsByType,
  } = props;
  const [paramsToShow, setParamsToShow] = useState([]);
  const history = useHistory();

  const setHeight = item => {
    setValue(item);
    if (history.location.pathname.includes('height-settings')) {
      if (wardrobesConfigs.length) {
        setWardrobesConfigs([]);
        resetFrontsByType();
      }
    }
  };

  useEffect(() => {
    let activeElementValue;
    activeElementValue = activeValue ? activeValue : params[0];
    if (params.length) {
      setParamsToShow(
        params.map(item => {
          return { value: item, check: item === activeElementValue };
        }),
      );
    }
  }, [params, activeValue]);

  return (
    <div className="selection-buttons">
      <p className="selection-buttons__title">{title}</p>
      <div className="selection-buttons__box">
        {paramsToShow.map(param => {
          let item = param.value;
          let checked = param.check;
          return (
            <div
              className={`selection-buttons__item ${
                checked ? 'selection-buttons__item__checked' : ''
              }`}
              key={`${selectionGroupName}-selection-${item}`}>
              <input
                className="selection-buttons__input "
                type="radio"
                id={`${selectionGroupName}-${item}`}
                name={selectionGroupName}
                defaultChecked={checked}
                onChange={() => setHeight(item)}
              />
              <label
                className="selection-buttons__label"
                htmlFor={`${selectionGroupName}-${item}`}
                radioGroup={selectionGroupName}>
                {item} {unit}
              </label>
            </div>
          );
        })}
      </div>
    </div>
  );
};

SelectionButtons.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  params: PropTypes.array.isRequired,
  selectionGroupName: PropTypes.string.isRequired,
  setValue: PropTypes.func.isRequired,
  activeValue: PropTypes.number,
  setWardrobesConfigs: PropTypes.func,
  wardrobesConfigs: PropTypes.arrayOf(PropTypes.object),
};

const mapDispatchToProps = dispatch => {
  return {
    resetFrontsByType: () => dispatch(resetFrontsByType()),
  };
};

export default connect(null, mapDispatchToProps)(SelectionButtons);
